import gql from 'graphql-tag';

// No `errorCode` field here, deliberately. A 409 from create means the payer side
// already has an active master on that product or at that priority - a duplicate,
// which the operator fixes by ending the existing one. That is a different problem
// from losing an optimistic-lock race, so it must not arrive as STALE_VERSION.
// `errors[0]` carries the reason to display.
const createDefaultCoverageMasterMutation = gql`
  mutation CreateDefaultCoverageMaster($input: CreateDefaultCoverageMasterInput!) {
    createDefaultCoverageMaster(input: $input) {
      success
      errors
      defaultCoverageMaster {
        id
        masterType
        productId
        productCode
        version
        priceDs
        startTs
        endTs
        resolving
      }
    }
  }
`;

export default createDefaultCoverageMasterMutation;
